import { useHistory } from "react-router-dom"
import ProductOderDetail from "@Components/OrderDetail/ProductOrderConfirm/ProductOderDetail"
import PickingAction from "@Components/OrderDetail/ProcessProducts/PickingAction"
import ProcessProductsList from "@Components/OrderDetail/ProcessProducts/ProcessProductsList"
import AlertStyled from "@Theme/common/Alert.styled"
import UseConfirmOrder from "@Pages/DetailOrderScreens/Confirm/UseConfirmOrder"
import { SecondtitleStyled } from "@Theme/common/Paragraph.styled"
import { IProcessItem } from "@Interfaces/IItemsOrder"
import OrderDetailHOC from "@Hoc/OrderDetailHOC"
import { OrderDetailType } from "@Types/OrderType"
import SummaryProductList from "@Components/OrderDetail/SummaryProducts/SummaryProductsList"
import { LinkIconStyled } from "@Theme/common/Link.styled"
import { IconArrowOutlineRigth, IconBackArow, IconCancel } from "@Theme/common/Icon.styled"
import { ButtonStyled } from "@Theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "@Theme/common/ContentDetailOrderActions.styled"
import useUserPermissions from "@Hooks/UseUserPermissions"
import { useGetCancelActionByClient } from "@Hooks/UseGetMultiClient"
import useHideActionButtons from "@Hooks/UseHideActionButtons"
import { useEffect } from "react"

const ConfirmOrderScreen = ({
  order,
  shippinGroupDetail,
  shippingGroupId,
  setFinishedShippingGroupAction,
  finishedShippingGroupAction,
}: OrderDetailType) => {
  const [permissionOrder, actionOrder] = useGetCancelActionByClient()
  const {hideConfirmActions, updateVisibilityButtonActions} = useHideActionButtons()

  useEffect(() => {
    updateVisibilityButtonActions(
      shippinGroupDetail?.source?.id,
      shippinGroupDetail?.target?.source?.id
    )
  }, [shippinGroupDetail, updateVisibilityButtonActions])

  const history = useHistory()

  const itemsOrder = shippinGroupDetail?.source.items

  const {
    currentItem,
    nextItems,
    itemsAllProcessed,
    loadingConfirm,
    loadingCancel,
    handleClickConfirmOrder,
    handleClickCancelOrder,
    backToScan,
    dispachPickingTransition,
    pickingTransition,
  } = UseConfirmOrder({
    order,
    itemsOrder,
    shippingGroupId,
    setFinishedShippingGroupAction,
  })

  const { permission } = useUserPermissions({ resources: [
    permissionOrder
  ] })
  
  //events
  const handleClickProcessProduct = (item: IProcessItem) => {
    if (item) {
      if (pickingTransition.isEditing) {
        const nextItemIndex = itemsOrder?.findIndex(
          (item) => !pickingTransition.processItems.some(({ sku }) => sku === item.sku),
        )
        dispachPickingTransition({
          type: "EDIT_ITEM_SERIES",
          payload: {
            itemEdit: item,
            nextItemIndex: nextItemIndex || -1,
          },
        })

        return
      }
      dispachPickingTransition({ type: "ADD_PROCESS_ITEM", payload: item })
    }
  }

  const handleClickBackToScan = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    backToScan()
  }
  const handleClickEdit = (sku: string) => {
    dispachPickingTransition({ type: "CHANGE_ITEM_ACTIVE_FOR_EDIT", payload: sku })
  }

  const handleClickCancel = () => {
    handleClickCancelOrder(actionOrder)
  }

  return (
    <>
      {!finishedShippingGroupAction ? (
        <>
          {permission[permissionOrder] && !hideConfirmActions && (
            <ContentDetailOrderActionsStyled>
              <ButtonStyled
                variant="secondary"
                onClick={handleClickCancel}
                loadingButton={loadingCancel}
                disabled={loadingCancel}
              >
                <IconCancel />
                <span>Cancelar Orden</span>
              </ButtonStyled>
            </ContentDetailOrderActionsStyled>
          )}
          {itemsAllProcessed && (
            <LinkIconStyled to="#" className="padding-content" onClick={handleClickBackToScan}>
              <IconBackArow />
              <span>Regresar</span>
            </LinkIconStyled>
          )}
          <AlertStyled variant="default">
            <p>
              Para continuar, necesita escanear <br />
              todos los productos
            </p>
          </AlertStyled>
          {!itemsAllProcessed && (
            <>
              {itemsOrder && (
                <SecondtitleStyled className="m-top1">
                  {pickingTransition.itemIdexActive + 1} de {itemsOrder.length}
                </SecondtitleStyled>
              )}
              <ProductOderDetail
                itemOrder={currentItem}
                onClicProcessProduct={handleClickProcessProduct}
                source={shippinGroupDetail?.source.id}
                hideConfirmActions={hideConfirmActions}
              />
            </>
          )}
          <ProcessProductsList
            processItems={pickingTransition.processItems}
            onClickEditItem={handleClickEdit}
          />
          {itemsAllProcessed && (
            <>
              <PickingAction
                loadingConfirm={loadingConfirm}
                onClickConfirmOrder={handleClickConfirmOrder}
              />
            </>
          )}
          {nextItems.length > 0 && (
            <>
              <SummaryProductList
                itemsOrder={nextItems}
                groupPicking={false}
                titleMain={"Productos"}
              />
            </>
          )}
        </>
      ) : (
        <>
          <div className="padding-content">
            <ButtonStyled
              variant="primary"
              fullSize={true}
              onClick={() =>
                history.push(`/order/package/${shippingGroupId}/${shippinGroupDetail?.orderId}`)
              }
            >
              <span>Ir a empacar</span>
              <IconArrowOutlineRigth />
            </ButtonStyled>
          </div>
          <SummaryProductList itemsOrder={pickingTransition.processItems} groupPicking={true} />
        </>
      )}
    </>
  )
}

export default OrderDetailHOC(ConfirmOrderScreen)
